import { Time } from '@angular/common';

export abstract class BaseEntity {
  version?: number;

  uuid = '';

  createdBy?: string;

  createdAt?: Time;

  lastUpdateBy?: string;

  lastUpdateAt?: Time;

  id: number;

  new = true;

  active = true;
}
